import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const InstructionsContainer = styled.div`
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 20%;
    max-height: 20%;
    & > h3 {
      font-size: 32px;
      margin: 12.5px;
      color: #335B80;
      font-weight: 700;
    }
    & > p {
      font-size: 16px;
      margin: 2.5px;
      color: #335B80;
    }
`;

const Instructions = ({
    title,
    explanation,
    importedFileActiveStep,
}) => (
  <InstructionsContainer>
    <h3>{importedFileActiveStep + 1}. {title}</h3>
    <p>{explanation}</p>
  </InstructionsContainer>
);

Instructions.propTypes = {
  title: PropTypes.string,
  explanation: PropTypes.string,
  importedFileActiveStep: PropTypes.number,
};

export default Instructions;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/blocks/instructions.js